const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_GENERAL_MANAGMENT_BEGINS: "GET_GENERAL_MANAGMENT_BEGINS",
  GET_GENERAL_MANAGMENT_SUCCESS: "GET_GENERAL_MANAGMENT_SUCCESS",
};

export const initialState = {
  generalManagmentData: null,
  generalManagmentFetching: null,
};

export const actions = {
  getGeneralMangament: (alias) => ({
    type: types.GET_GENERAL_MANAGMENT_BEGINS,
    alias,
  }),
  successGeneralMangament: (data) => ({
    type: types.GET_GENERAL_MANAGMENT_SUCCESS,
    payload: { data },
  }),
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { generalManagment } = payload;
      return {
        ...state,
        ...generalManagment,
      };
    }
    case types.GET_GENERAL_MANAGMENT_BEGINS:
      return {
        ...state,
        generalManagmentFetching: true,
      };
    case types.GET_GENERAL_MANAGMENT_SUCCESS:
      const { data } = payload;
      return {
        ...state,
        generalManagmentData: data,
        generalManagmentFetching: false,
      };
    default:
      return state;
  }
}

export default reducer;
